import store from "@/store";
import Vue from "vue";
import VueRouter from "vue-router";
import { checkAccess, checkTokenExpiry, getCookieToken, clearCookies } from "@/utils/tokenCheck";
Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "Layout",
		redirect: "/wallet",
		component: () => import("@/components/Layout/Layout.vue"),
		children: [
			{
				path: "/wallet",
				name: "Wallet",
				component: () => import("@/views/Wallet/Wallet.vue"),
			},
		],
	},
	{
		path: "/login",
		name: "Login",
		component: () => import("@/views/Login/Login.vue"),
	},
];

const router = new VueRouter({
	mode: "history",
	scrollBehavior: () => ({ y: 0 }),
	routes,
});

router.beforeEach(async (to, from, next) => {
	if (checkAccess()) {
		const hasToken = getCookieToken();
		const expiryTime = checkTokenExpiry();
		if (hasToken && store.getters.userData === null) {
			await store.dispatch("userVUEX/getUserData");
			if (to.name == 'Login') next('/')
			else next();
		}
		else if (hasToken && expiryTime) {
			if (to.name == 'Login') next('/')
			else next();
		} else {
			clearCookies();
			location.replace("https://app.hire3x.com/login");
		}
	}
	else {
		clearCookies();
		location.replace("https://app.hire3x.com/login");
	}
});
export default router;
